import { createContext } from "react";

export const MappingContext = createContext({});